import {ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {DYNAMIC_FIELDS} from "../../dynamic-fields.config";
import {DetailConfigurationField} from "../../../../models/detail-configuration-field";

@Directive({
	selector: "[tigDynamicField]"
})
export class DynamicFieldDirective implements OnInit
{

	/**
	 * Attributes
	 */
	@Input()
	OBJ_field_config: DetailConfigurationField;
	@Input()
	OBJ_form_group: FormGroup;
	private OBJ_component;

	/**
	 * Function > constructor
	 * @param {object} OBJ_component_factory_resolver
	 * @param {object} OBJ_view_container_ref
	 */
	constructor
	(
		private OBJ_component_factory_resolver: ComponentFactoryResolver,
		private OBJ_view_container_ref: ViewContainerRef
	)
	{
	} // end function constructor

	/**
	 * Function > ngOnInit
	 */
	ngOnInit()
	{

		// embedded objects
		let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
		if (this.OBJ_field_config.type === 'assignments' && typeof this.OBJ_field_config.fields !== 'undefined' && OBJ_form_control instanceof FormGroup) // TODO besser machen
		{

			for (let OBJ_field of this.OBJ_field_config.fields)
			{
				this.initializeComponent(OBJ_field, OBJ_form_control);
			} // end for

		}
		else
		{
			this.initializeComponent(this.OBJ_field_config, this.OBJ_form_group);
		} // end if

	} // end function ngOnInit

	/**
	 * Function > initializeComponent
	 * @param OBJ_field_config
	 * @param OBJ_form_group
	 */
	private initializeComponent(OBJ_field_config, OBJ_form_group)
	{
		// only allowed fields
		if (typeof DYNAMIC_FIELDS[OBJ_field_config.type] !== "undefined")
		{

			const OBJ_component = DYNAMIC_FIELDS[OBJ_field_config.type];
			const OBJ_factory = this.OBJ_component_factory_resolver.resolveComponentFactory<any>(OBJ_component);
			this.OBJ_component = this.OBJ_view_container_ref.createComponent(OBJ_factory);
			this.OBJ_component.instance.OBJ_field_config = OBJ_field_config;
			this.OBJ_component.instance.OBJ_form_group = OBJ_form_group;

		} // end if

	} // end function initializeComponent

} // end class DynamicFieldDirective
